window.theme.section('listing', (el) => {
    //console.log('listing script loaded.');
});